<!-- Backdrop with blur and gradient -->
<div class="menu-backdrop" (click)="handleBackdropClick()" aria-label="Close menu overlay"></div>

<div class="menu-cards-container">
  @if (expandedOptionId()) {
    <!-- Generic expanded card slot -->
    <div class="expanded-card">
      <ng-content></ng-content>
    </div>
  } @else {
    <!-- Dynamic grid of menu option cards -->
    <div class="menu-cards-grid">
      @for (option of menuConfig().options; track option.id) {
        <button class="menu-card" (click)="handleOptionClick(option, $event)" type="button" [attr.data-testid]="'menu-option-' + option.id" [attr.aria-label]="option.label | transloco">
          <div class="menu-card-icon">
            <ion-icon [name]="option.iconName" [src]="option.iconSrc" [attr.aria-label]="option.label | transloco"></ion-icon>
          </div>

          <span class="menu-card-label">
            {{ option.label | transloco }}
          </span>
        </button>
      }
    </div>
  }
</div>
